import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiscover = (props) => /* @__PURE__ */ _jsx("svg", {
	height: 20,
	viewBox: "0 0 32 20",
	width: 32,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("rect", {
			fill: "#fff",
			height: 19,
			rx: 2,
			stroke: "#e6772f",
			width: 29,
			x: 1.5,
			y: .5
		}), /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "m7.03847227 20h21.96152773l2-2v-6.7673105s-8.4625899 6.0566428-23.96152773 8.7673105z",
					fill: "#e7772f"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m5.15381689 9.9406717c-.25718035.2139648-.58457398.3075276-1.10811393.3075276h-.21724251v-2.55333363h.21724251c.52353995 0 .8383725.08726526 1.10811393.31187586.27843757.2321076.44575777.59016507.44575777.96051764 0 .37215186-.1673202.74295426-.44575777.97341253zm-.94594698-2.89984567h-1.18863378v3.86171277h1.18138699c.62869885 0 1.08250862-.1392946 1.48027659-.4466722.47249038-.3640551.75286042-.91373627.75286042-1.48320957 0-1.1399962-.91470528-1.931831-2.22589022-1.931831z",
					fill: "#1a1918"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m6.80688905 7.04082603h.80600351v3.86171277h-.80600351z",
					fill: "#1a1918"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m9.59223109 8.52088687c-.48650086-.16613387-.62869886-.27678984-.62869886-.48550674 0-.24260343.25412059-.4265802.60357666-.4265802.24220365 0 .44173181.09026407.65430411.31082627l.4207967-.51399537c-.3476846-.2848866-.76381113-.4291292-1.21745989-.4291292-.73401877 0-1.29347058.47546074-1.29347058 1.10416047 0 .53378753.26007906.80457973 1.01905901 1.06172737.31724813.1027091.47844883.17288116.56009594.22041226.16168384.09731127.24220365.23675574.24220365.39794157 0 .314125-.26732582.5450331-.62869885.5450331-.38472374 0-.69601342-.1793287-.88233632-.5160946l-.52144641.4702128c.37280682.5085976.81969189.7359071 1.43534652.7359071.83966083 0 1.43132053-.5234417 1.43132053-1.2689449 0-.61430547-.2744116-.89274463-1.19459221-1.20596993",
					fill: "#1a1918"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m11.0409439 8.97265703c0 1.13564797.9573808 2.01564767 2.1898173 2.01564767.3475236 0 .645447-.0638746 1.0122954-.2250605v-.88749667c-.3241729.30332927-.60873.42298167-.9768666.42298167-.8143776 0-1.3912217-.54863163-1.3912217-1.33147003 0-.73965557.5955247-1.3256223 1.3557929-1.3256223.3835965 0 .6766887.12654963 1.0122954.4343771v-.88644714c-.3544483-.16688356-.6452859-.23600606-.9957083-.23600606-1.2253508 0-2.2064044.89724283-2.2064044 2.01909626",
					fill: "#1a1918"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m20.7960826 9.633444-1.1060204-2.59261797h-.8818532l1.758231 3.95917397h.4336799l1.7923714-3.95917397h-.8749285z",
					fill: "#1a1918"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m23.1595007 10.9025388h2.293688v-.6543395h-1.4844637v-1.0423851h1.4280998v-.65418957h-1.4280998v-.85675896h1.4844637v-.65403964h-2.293688z",
					fill: "#1a1918"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m27.0329877 8.81656917h-.2347958v-1.16803504h.2480011c.5053425 0 .7760501.1974714.7760501.57367164 0 .38654613-.2707076.5943634-.7892554.5943634zm1.6221526-.6363467c0-.72316214-.5327192-1.13939644-1.4665882-1.13939644h-1.2013559v3.86171277h.8109957v-1.55263193h.1051589l1.1174543 1.55263193h.995064l-1.3049044-1.6276021c.6098572-.1160538.9441756-.50379947.9441756-1.09471423z",
					fill: "#1a1918"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "m18.8300004 8.98165343c0 1.11180747-.9017259 2.01294867-2.0150751 2.01294867-1.1130491 0-2.0149251-.9011412-2.0149251-2.01294867 0-1.11195733.901876-2.01324856 2.0149251-2.01324856 1.1133492 0 2.0150751.90129123 2.0150751 2.01324856",
					fill: "#e7772f"
				})
			]
		})]
	})
});
export default SvgDiscover;
